import { render } from "./importtoformlibrary.vue?vue&type=template&id=3d7900c2&scoped=true"
import script from "./importtoformlibrary.js?vue&type=script&lang=js"
export * from "./importtoformlibrary.js?vue&type=script&lang=js"

import "./importtoformlibrary.vue?vue&type=style&index=0&id=3d7900c2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d7900c2"]])

export default __exports__